import React from 'react'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Kicks! by</p>
      </div>
      <div className="footer-content">
        <a href='https://github.com/vjmreysantos' target='_blank' rel='noreferrer'> Victor Reysantos </a>
      </div>
      <div className="footer-content container-row justify-content-end">
        <p>&nbsp;Copyright &copy; 2021 All Rights Reserved</p>
      </div>
    </footer>
  )
}

export default Footer